import { Input } from "@biteship/atom";

export default function InstantRatesForm(props) {
  const onChange = (key, value) => {
    props.setInputData({
      ...props.inputData,
      [key]: value,
    });
  };

  return (
    <div className="p-2">
      {props.useType === "create" && (
        <div>
          <div className="flex justify-between space-x-2 mb-4 mt-2">
            <Input
              label="Koordinat Latitude Asal"
              placeholder={`Masukkan Latitude`}
              className="w-full"
              value={props.inputData.originLat}
              onChange={(e) => onChange("originLat", e.target.value)}
            />
            <Input
              label="Koordinat Longitude Asal"
              placeholder={`Masukkan Longitude`}
              className="w-full"
              value={props.inputData.originLng}
              onChange={(e) => onChange("originLng", e.target.value)}
            />
          </div>
          <div className="flex justify-between space-x-2 mb-4">
            <Input
              label="Koordinat Latitude Tujuan"
              placeholder={`Masukkan Latitude`}
              className="w-full"
              value={props.inputData.destinationLat}
              onChange={(e) => onChange("destinationLat", e.target.value)}
            />
            <Input
              label="Koordinat Longitude Tujuan"
              placeholder={`Masukkan Longitude`}
              className="w-full"
              value={props.inputData.destinationLng}
              onChange={(e) => onChange("destinationLng", e.target.value)}
            />
          </div>
        </div>
      )}

      <Input
        label={`Harga Dasar`}
        placeholder={`Harga (wajib)`}
        className="w-full mb-4 mt-2"
        type="number"
        addOns="leading"
        value={props.inputData.basePrice}
        onChange={(e) => onChange("basePrice", e.target.value)}
      />
      <div className="flex justify-between space-x-2 mb-4 mt-2">
        <Input
          label={`Harga Tambahan / kg`}
          placeholder={`Harga (optional)`}
          className="w-full"
          type="number"
          addOns="leading"
          value={props.inputData.weightExtraPrice}
          onChange={(e) => onChange("weightExtraPrice", e.target.value)}
        />
        <Input
          label={`Harga Tambahan / cm 3`}
          placeholder={`Harga (optional)`}
          className="w-full"
          type="number"
          addOns="leading"
          value={props.inputData.volumeExtraPrice}
          onChange={(e) => onChange("volumeExtraPrice", e.target.value)}
        />
        <Input
          label={`Harga Tambahan / km`}
          placeholder={`Harga (optional)`}
          className="w-full"
          type="number"
          addOns="leading"
          value={props.inputData.distanceExtraPrice}
          onChange={(e) => onChange("distanceExtraPrice", e.target.value)}
        />
      </div>
    </div>
  );
}
